import axios from "axios";
import { Message, MessageBox } from "element-ui";
import {
  getAntiRepeat,
  getClientHeader,
  saveAntiRepeat,
  LoginTokenKey,
} from "@/utils/auth";
// 创建axios实例
const service = axios.create({
  baseURL: process.env.VUE_APP_BASE_API, // api 的 base_url
  timeout: 20000, // 请求超时时间
});

// request拦截器
service.interceptors.request.use(
  (config) => {
    let tt = getClientHeader();
    config.headers["Warlock-Sign"] = tt.sign;
    config.headers["Warlock-Token"] = tt.token;
    config.headers["Warlock-Type"] = tt.type;
    let antObj = getAntiRepeat();
    if (!!antObj.antiRepeatToken) {
      config.headers["antiRepeat"] = antObj.antiRepeatToken;
      saveAntiRepeat({ lastAntiRepeatToken: antObj.antiRepeatToken });
    }
    return config;
  },
  (error) => {
    Promise.reject(error);
  }
);

// response 拦截器
service.interceptors.response.use(
  (response) => {
    const res = response.data;
    let headers = response.headers;
    if (!!headers) {
      let antObj = getAntiRepeat();
      //lastAntiReatToken是没用处的，当时出现问题是后台防重复的时候没有防住，当时用的session的id，spring重建session，id不一致,可以用jsessionid这个header来处理
      //实际中用的是redis，更阻塞
      if (
        headers.get("antiRepeat") &&
        headers.get("antiRepeat") !== antObj.antiRepeatToken &&
        headers.get("antiRepeat") !== antObj.lastAntiRepeatToken
      ) {
        saveAntiRepeat({ antiRepeatToken: headers.get("antiRepeat") });
      }
    }
    //未登录状态 关闭
    if (
      (res?.code == "1" && res?.msg?.includes("没有登录系统")) ||
      (res.code == 2 
        // && res?.msg?.includes("请您首先登录")
      )
    ) {
      MessageBox.confirm("您未登录，请先登录数字绩效系统！", "关闭", {
        confirmButtonText: "关闭",
        type: "warning",
        showCancelButton: false,
        showClose: false,
        closeOnClickModal: false,
      }).then(() => {
        localStorage.removeItem(LoginTokenKey);
        window.close();
      });
      return response?.data;
    } else {
      return response?.data;
    }
  },
  (error) => {
    Message({
      message: error.message,
      type: "error",
      duration: 5 * 1000,
    });
    // return Promise.reject(error.message);
    return { code: 500, msg: error.message };
  }
);

export default service;
